import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './styles.scss';
import logo from '../../assets/images/logo/logo.png';
import logodark from '../../assets/images/logo/logo_dark.png';
import DarkMode from './DarkMode';
import Lang from './lang';
import User from './user';
import { useTranslation } from 'react-i18next';

import CurrencySwitcher from './CurrencySwitcher';

const Header = ({ islogin }) => {
    const [scroll, setScroll] = useState(false);
    const [mobile, setMobile] = useState(false);
    const menuRef = useRef(null);  // Référence pour le menu
    const [menuActive, setMenuActive] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);  // Garder l'index actif
    const navigate = useNavigate();

    useEffect(() => {
        setMobile(window.innerWidth < 768);
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 300);
        });

        setActiveIndex(menusdata.findIndex(menu => menu.links === window.location.pathname));

        // Fermer le menu si on clique en dehors
        // const handleClickOutside = (event) => {
        //     if (menuRef.current && !menuRef.current.contains(event.target) && menuActive) {
        //         setMenuActive(false);  // Fermer le menu
        //         // Si vous souhaitez également désactiver l'élément actif, vous pouvez le réinitialiser ici
        //         setActiveIndex(null);
        //     }
        // };
        const handleClickOutside = (event) => {
            if (menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !event.target.closest('.mobile-button') && // Exclude mobile button
                menuActive) {
                setMenuActive(false);
                setActiveIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuActive]);

    const { t } = useTranslation();

    function getLangName(code) {
        const langNames = {
            ar: "العربية",
            fr: "Français",
            en: "English",
            es: "Español",
            tr: "Türkçe",
            ru: "Русский",
            pt: "Português",
            nl: "Nederlands",
            de: "Deutsch",
            it: "Italiano",
            zh: "中文",
        };
        return langNames[code] || "Language";
    }

    const menusdata = [
        { id: 1, name: t('Home'), links: '/' },
        { id: 2, name: t('About'), links: '/about-us' },
        { id: 4, name: t('Offers'), links: '/collection' },
        { id: 7, name: t('Contact'), links: '/contact' },
        // { id: 8, name: t('login'), links: '/signin' },

        ...(!islogin ? [{ id: 8, name: t('login'), links: '/signin' }] : []), // 👈 Afficher seulement si déconnecté
    ];

    const menus = !mobile ? menusdata.slice(0, 4) : menusdata;

    // const handleMenuActive = () => {

    //     setMenuActive(!menuActive);
    // };

    const handleMenuActive = (e) => {
        e.stopPropagation(); // Prevent event from bubbling
        setMenuActive(!menuActive);
    };
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const handleItemClick = (index) => {
        // Ferme le menu principal après avoir cliqué sur un élément et garde l'élément actif
        setMenuActive(false);
        setActiveIndex(index);  // Garder l'élément sélectionné
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    const handleClickHome = () => {
        setActiveIndex(0);
        navigate('/');
    };
    return (
        <header style={{ zIndex: 10 }} className={`header ${scroll ? 'is-fixed' : ''}`}>
            <div className="tf-container">
                <div className="row">
                    <div className="col-md-12">
                        <div id="site-header-inner" style={{ display: "flex", justifyContent: "space-between" }}>
                            <div id="site-logo" className="clearfix">
                                <div id="site-logo-inner">
                                    <div rel="home" onClick={() => handleClickHome()} className="main-logo d-flex align-items-center" style={{ cursor: "pointer" }}>
                                        <img id="logo_header" className='logo-dark' src="/images/logos/logo.png" alt="Binasea" style={{ width: "60px" }} />
                                        <img id="logo_header" className='logo-light' src="/images/logos/logo.png" alt="Binasea" style={{ width: "60px" }} />
                                        <h5 id="masterf" style={{ color: "var(--primary-color3) !important" }}>MASTERFUT</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="header-center">
                                <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`} ref={menuRef}>
                                    <ul id="menu-primary-menu" className="menu">
                                        {menus.map((data, idx) => (
                                            <li
                                                key={idx}
                                                onClick={() => handleDropdown(idx)}
                                                className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === idx ? 'active' : ''}`}
                                            >
                                                <Link
                                                    to={data.links}
                                                    onClick={() => handleItemClick(idx)}
                                                    className={activeIndex === idx || activeIndex === 0 ? 'active-link' : ''}
                                                >
                                                    {data.name}
                                                </Link>
                                                {data.namesub && (
                                                    <ul className="sub-menu">
                                                        {data.namesub.map((submenu) => (
                                                            <li key={submenu.id} className="menu-item">
                                                                <NavLink
                                                                    to={submenu.links}
                                                                    onClick={() => handleItemClick(idx)}
                                                                    className={activeIndex === idx ? 'active-link' : ''}
                                                                >
                                                                    {submenu.sub}
                                                                </NavLink>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>

                            <div className="header-right">
                                <DarkMode />
                                <Lang />
                                <CurrencySwitcher />
                                <User />

                                <div
                                    className={`mobile-button ${menuActive ? 'active' : ''}`}
                                    onClick={(e) => handleMenuActive(e)}
                                >
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
